export const appointmentsUrl = `/api/v1/appointments`;
export const attachmentPath = '/attachments';
export const appointmentDocumentUrl = '/api/v1/appointments/document';
export const appointmentOptionsUrl = '/api/v1/appointments/options';
export const getAppointmentAttachmentsUrl = (appointmentId) => `/api/v1/appointments/${appointmentId}/attachments`;
export const sitesUrl = '/api/v1/sites';
